import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Isvg from 'react-inlinesvg';
import { useDispatch } from 'react-redux';
import styleable from 'react-styleable';
import modalActions from '../../../containers/modal-container/modal-actions';
import {
    CONFIGURATION_KEYS,
    MATHLETICS_ID,
    TOTAL_CERTIFICATES_TYPE
} from '../../../helpers/constants';
import { getConfiguration } from '../../../helpers/utils';
import CertificateConfirmationModal from '../../certificates/components/certificate-confirmation-modal/certificate-confirmation-modal';
import { useCertificatesToast } from '../../certificates/hooks/use-certificates-toast';
import DownloadIcon from './assets/download-icon.svg';

import css from './certificate-display.scss';
import certificatesActions from '../../certificates/certificates-actions';

const CertificateDisplay = ({
    count,
    requestParams,
    service,
    onSuccessParams,
    isOldCertificates
}) => {
    const dispatch = useDispatch();
    const { renderedToast, onOpenToast } = useCertificatesToast();
    const handleDownloadClick = ({
        fullColor = false,
        gemTypes = [],
        gemCount
    }) => {
        const { startDate, endDate, ...params } = requestParams;
        const requestPayload = {
            startDate: moment(startDate).format('DD-MM-YYYY'),
            endDate: moment(endDate).format('DD-MM-YYYY'),
            productId: MATHLETICS_ID,
            ...params,
            certificatesCount: gemCount,
            ...onSuccessParams,
            ...(!isOldCertificates && { gemTypes, fullColor })
        };

        dispatch(service(requestPayload));
    };

    const onClickHandler = async () => {
        const maxCertificatesCanDownload =
            (await getConfiguration(
                CONFIGURATION_KEYS.MAX_CERTIFICATES_CAN_DOWNLOAD
            )) || 200;

        if (count > maxCertificatesCanDownload) {
            onOpenToast();
        } else if (!isOldCertificates) {
            const {
                type,
                startDate,
                endDate,
                classroomId,
                groupId,
                userProfileId,
                yearGroupEnum
            } = requestParams;
            const dispatchModal = () => {
                dispatch(
                    modalActions.openModal({
                        content: (
                            <CertificateConfirmationModal
                                certificatesCount={count}
                                certificateType={requestParams.type}
                                handleDownloadClick={handleDownloadClick}
                            />
                        ),
                        buttons: []
                    })
                );
            };
            if (type !== TOTAL_CERTIFICATES_TYPE) {
                const requestPayload = {
                    type,
                    startDate: moment(startDate).format('DD-MM-YYYY'),
                    endDate: moment(endDate).format('DD-MM-YYYY'),
                    classroomId,
                    groupId,
                    studentUserProfileId: userProfileId,
                    yearGroupEnum
                };
                dispatch(
                    certificatesActions.getGemCountsByType(requestPayload)
                ).then(dispatchModal());
            } else {
                dispatchModal();
            }
        } else {
            // download old certificates without showing modal
            handleDownloadClick({ gemCount: count });
        }
    };

    return (
        <div className={css.container}>
            {renderedToast}
            <div className={css.wrapper}>
                {count === 0 ? (
                    <div className={css.dash} />
                ) : (
                    <div
                        className={css.button}
                        onClick={onClickHandler}
                        role="button"
                        tabIndex={0}
                    >
                        <span className={css.title}>{count}</span>
                        <Isvg
                            className={css.icon}
                            src={DownloadIcon}
                            cacheGetRequests
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

CertificateDisplay.propTypes = {
    count: PropTypes.number.isRequired,
    requestParams: PropTypes.shape({
        classroomId: PropTypes.number,
        startDate: PropTypes.string || null,
        endDate: PropTypes.string || null,
        groupId: PropTypes.number,
        isForDownload: PropTypes.bool,
        userProfileId: PropTypes.string || null
    }),
    service: PropTypes.func,
    onSuccessParams: PropTypes.shape({
        certificateType: PropTypes.number,
        certificatesCount: PropTypes.number,
        className: PropTypes.string
    }),
    isOldCertificates: PropTypes.bool
};

CertificateDisplay.defaultProps = {
    count: 0
};

export default styleable(css)(CertificateDisplay);



// WEBPACK FOOTER //
// ./components/participation-table/certificate-display/certificate-display.js